import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../../HTH";
import {gsap} from "gsap";
import {HTHSymbol} from "../../symbols/HTHSymbol";
import {HTHScatterSymbol} from "../../symbols/HTHScatterSymbol";
import {HTHGameMode} from "../../server/HTHGameMode";
import {HTHGameConfig} from "../../HTHGameConfig";

export class HTHScatterCollectionPresentation implements SimplePresentation {
    constructor() {
    }

    shouldRun(): boolean {
        return HTH.model.isScatterPresent && !HTH.model.mode.includes("NORMAL") && (HTH.model.nextMode === HTHGameMode.FREESPIN || HTH.model.nextMode === HTHGameMode.EXTRA_SPIN || HTH.model.nextMode === HTHGameMode.NORMAL);
    }

    start(controller: SimplePresentationRunnerController) {
        const scTl: gsap.core.Timeline = gsap.timeline(
            {
                onComplete: () => {
                    HTH.screenInteractive.setInteractiveState(false);
                    controller.setSkipCallback();
                    controller.finish()
                }
            }
        );

        if (HTH.model.gameData?.betWayWins.length === 0) {
            HTH.screenInteractive.setInteractiveState(true);
            if (HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
                //console.log("already at 1st skip scattercollectionpresentation");
                scTl.timeScale(2);
            } else if (HTHGameConfig.isSkipped[1]) {
                //console.log("already at 2nd skip scattercollectionpresentation");
                scTl.timeScale(4);
                HTH.screenInteractive.setInteractiveState(false);
            }
        }

        HTH.screenInteractive.clickArea.on('pointerdown', () => {
            if (!HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
                //console.log("1st skip scattercollectionpresentation");
                HTHGameConfig.isSkipped[0] = true;
                scTl.timeScale(2);
            } else if (HTHGameConfig.isSkipped[0] && !HTHGameConfig.isSkipped[1]) {
                HTHGameConfig.isSkipped[1] = true;
                //console.log("2nd skip scattercollectionpresentation");
                scTl.timeScale(4);
                HTH.screenInteractive.setInteractiveState(false);
            }
        });

        if (HTH.model.gameData?.betWayWins.length > 0) {
            controller.setSkipCallback(() => { //keeping in if condition because it was getting click before interactive screen
                scTl.timeScale(2);
            });
        }


        const scatterData = HTH.model.scatterCoordinatesPerReel;

        scatterData.forEach((reelData, i) => {
            reelData.forEach((symData, j) => {

                const sym: HTHSymbol = HTH.reelArea.getSymbol([symData.reelId, symData.symId]);
                const indiTl: gsap.core.Timeline = gsap.timeline();
                HTH.gameViewContainer.scatterCollector.scatterCount++;

                indiTl.add((<HTHScatterSymbol>sym).playSpineAnim("flicker_meter", true, false));
                indiTl.add(HTH.gameViewContainer.scatterCollector.animateScatterCollector(HTH.gameViewContainer.scatterCollector.scatterCount % 3), "<");
                scTl.add(indiTl);

            })
            scTl.to(this, {duration: 0.1});
        })
    }
}